let legalEntities = require('../../actions/custom-order/legalEntities');
let { calcPriceGroup } = require('../groups/order');
let analytics = require('../../actions/analytics');
let utils = require('../../actions/utils');

module.exports = {
    onItemCheck: [
        legalEntities.changeValue,
        utils.setArg('category', 'checkbox_type_ownership'),
        [
            analytics.fillEventFromTreeChecked,
            {
                filled: [analytics.raiseArgsValueEvent],
                noEvent: []
            }
        ],
        ...calcPriceGroup
    ],

    onSetAll: [
        legalEntities.setAll,
        ...calcPriceGroup
    ],
};



// WEBPACK FOOTER //
// ./signals/custom-order/legal-entities.js